import React from "react";
import { observer } from "mobx-react-lite";
import { FormGroup, Switch } from "@blueprintjs/core";
import { ISwitchEditorProps, EditorWithFormGroup } from "./_types";

// SwitchAttrEditor
export const SwitchAttrEditor = observer(<D, K extends keyof D>(props: ISwitchEditorProps<D, K>) => {
	const { store, ...rest } = props;

	// Change handler
	const _onChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
		if (props.switchProps?.onChange) props.switchProps.onChange(ev);
		else store.toggle(props.name);
	};

	// --

	return <Switch onChange={_onChange} checked={!!store.data[props.name]} {...rest.switchProps} name={rest.name as string} />;
});

// SwitchAttrEditorGroup
export const SwitchAttrEditorGroup = <D, K extends keyof D>(props: EditorWithFormGroup<ISwitchEditorProps<D, K>>) => {
	const { formGroupProps, ...rest } = props;

	return (
		<FormGroup {...formGroupProps}>
			<SwitchAttrEditor {...rest} />
		</FormGroup>
	);
};
